var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-view-layout',{attrs:{"title":'Latest log messages'}},[_vm._l((_vm.$store.getters['logs/errorMessages'].slice().reverse()),function(msg,index){return _c('div',{key:index,style:({
      margin: '0',
      padding: '0',
      'font-size': '0.7em',
      'text-align': 'left',
      color: _vm.$vuetify.theme.error
    }),attrs:{"v-text":msg}},[_vm._v("\n    "+_vm._s(msg)+"\n  ")])}),(_vm.$store.getters['logs/errorMessages'].length > 0)?_c('app-view-spacer'):_vm._e(),_vm._l((_vm.$store.getters['logs/messages'].slice().reverse()),function(msg,index){return _c('div',{key:index + 'error',style:({
      margin: '0',
      padding: '0',
      'font-size': '0.7em',
      'text-align': 'left',
      color: index % 2 == 0 ? _vm.$vuetify.theme.secondary : _vm.$vuetify.theme.primary }),attrs:{"v-text":msg}},[_vm._v("\n    "+_vm._s(msg)+"\n  ")])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }